// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.video-canvas .button-area {
    position: absolute;
    top: 5px;
    left: 0px;
    right: 0px;
    pointer-events: none;
    text-align: center;
    z-index: 1;
    container-type: size;
    container-name: button-area;
}


.video-canvas .button-area button {
    pointer-events: all;
    margin: 2px;
    width: 40px;
    opacity: 0.8;
    background-color: var(--main-bg-color);
    border: none;
    border-radius: 5px;
    opacity: 0.3;
}

.video-canvas:hover .button-area button {
    opacity: 1;
}

.video-canvas .button-area button:hover {
    background-color: var(--highlight-bg-color-hover);
}

.video-canvas .button-area button i svg {
    width: 100%;
    height: 100%;
    fill: var(--main-fg-color);
    color: var(--main-fg-color);
}

.video-canvas .button-area button:hover {
    opacity: 1;
}

.video-canvas .button-area button.align-left {
    float: left;
}

.video-canvas .button-area button.align-right {
    float: right;
}

.video-canvas .button-area {
    padding: 5px;
}

.video-canvas.image-canvas .image-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
}
.video-canvas.image-canvas img.landscape {
    height: 100%;
}

.video-canvas.image-canvas img.portrait {
    width: 100%;
}


@container button-area (max-width: 200px) {
    .video-canvas .button-area button {
        width: 25cqi;
    }
}

@container button-area (min-width: 200px) and (max-width: 350px) {
    .video-canvas .button-area button {
        width: 45px;
    }
}

@container button-area (min-width: 350px) {
    .video-canvas .button-area button {
        width: 55px;
    }
}



  `, "",{"version":3,"sources":["webpack://./src/css/VideoCanvas.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,2BAA2B;AAC/B;;;AAGA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":["\n.video-canvas .button-area {\n    position: absolute;\n    top: 5px;\n    left: 0px;\n    right: 0px;\n    pointer-events: none;\n    text-align: center;\n    z-index: 1;\n    container-type: size;\n    container-name: button-area;\n}\n\n\n.video-canvas .button-area button {\n    pointer-events: all;\n    margin: 2px;\n    width: 40px;\n    opacity: 0.8;\n    background-color: var(--main-bg-color);\n    border: none;\n    border-radius: 5px;\n    opacity: 0.3;\n}\n\n.video-canvas:hover .button-area button {\n    opacity: 1;\n}\n\n.video-canvas .button-area button:hover {\n    background-color: var(--highlight-bg-color-hover);\n}\n\n.video-canvas .button-area button i svg {\n    width: 100%;\n    height: 100%;\n    fill: var(--main-fg-color);\n    color: var(--main-fg-color);\n}\n\n.video-canvas .button-area button:hover {\n    opacity: 1;\n}\n\n.video-canvas .button-area button.align-left {\n    float: left;\n}\n\n.video-canvas .button-area button.align-right {\n    float: right;\n}\n\n.video-canvas .button-area {\n    padding: 5px;\n}\n\n.video-canvas.image-canvas .image-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n}\n.video-canvas.image-canvas img.landscape {\n    height: 100%;\n}\n\n.video-canvas.image-canvas img.portrait {\n    width: 100%;\n}\n\n\n@container button-area (max-width: 200px) {\n    .video-canvas .button-area button {\n        width: 25cqi;\n    }\n}\n\n@container button-area (min-width: 200px) and (max-width: 350px) {\n    .video-canvas .button-area button {\n        width: 45px;\n    }\n}\n\n@container button-area (min-width: 350px) {\n    .video-canvas .button-area button {\n        width: 55px;\n    }\n}\n\n\n\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
